import { useEffect, useState } from "react";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { id: "what", label: "WHAT", num: "03" },
  { id: "method", label: "METHOD", num: "05" },
  { id: "programs", label: "PROGRAMS", num: "09" },
  { id: "work", label: "WORK", num: "12" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="nav-section"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-5 sm:px-10 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-display font-extrabold text-lg tracking-tight text-cream uppercase"
        >
          PARA<span className="text-acid">{"//"}</span>EL
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToSection(l.id)}
              className="group font-mono text-[11px] uppercase tracking-[0.25em] text-smoke hover:text-cream transition-colors duration-300"
            >
              <span className="text-dim group-hover:text-acid transition-colors duration-300 mr-1.5">{l.num}</span>
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-apply-btn"
          onClick={() => scrollToSection("apply")}
          className="bg-acid text-obsidian font-mono text-[11px] font-bold uppercase tracking-[0.2em] px-5 py-2.5 hover:bg-acid-hover hover:scale-[1.03] active:scale-[0.98] transition-transform duration-300"
        >
          Apply Now
        </button>
      </div>
    </header>
  );
};
